import { Helmet } from "react-helmet-async";

const SITE = "https://atappliancemaster.com";

// No HelmetProvider here. It now lives once in index.js.
export default function SEO({ title, description, path = "/", noindex = false }) {
  const url = `${SITE}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <meta name="robots" content={noindex ? "noindex, follow" : "index, follow"} />
      {!noindex && <link rel="canonical" href={url} />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="AT Appliance Repair and Maintenance" />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={`${SITE}/og-image.jpg`} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
}